module.exports = __webpack_public_path__ + "img/uma-4.1280f58d.jpg";